import { render, staticRenderFns } from "./block-note.vue?vue&type=template&id=d06fc514&scoped=true&"
import script from "./block-note.vue?vue&type=script&lang=js&"
export * from "./block-note.vue?vue&type=script&lang=js&"
import style0 from "./block-note.vue?vue&type=style&index=0&id=d06fc514&prod&scoped=true&lang=scss&"
import style1 from "./block-note.vue?vue&type=style&index=1&id=d06fc514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06fc514",
  null
  
)

export default component.exports